export default "__VITE_ASSET__B3Am6o18__"